import { EntityDto } from '../../config/appConfig'
import { BaseOverviewFilterType, ViewType } from './BaseOverviewFilter'
import { BaseOverviewSortingType } from './BaseSortMenu'
import * as React from 'react'
import { PropsWithChildren } from 'react'
import { Card, mergeClasses } from '@fluentui/react-components'
import { BaseOverviewCount, BaseOverviewProps, useOverviewStyles } from './BaseOverview'

export type BaseOverviewColumnProps<
    EntityT extends EntityDto,
    FilterT extends BaseOverviewFilterType,
    SortingT extends BaseOverviewSortingType<any>,
    HeaderT extends BaseOverviewCount = BaseOverviewCount,
> = PropsWithChildren<
    BaseOverviewProps<EntityT, FilterT, SortingT, HeaderT> & {
        columnFilterValues: FilterT
        columnIndex: number
        viewportTiny: boolean
        viewportNarrow: boolean
        viewportMedium: boolean
        viewType: ViewType
        dragActive: boolean
        isDragOver: boolean
        onColumnDragOver: (event: React.DragEvent, targetColumnIndex: number) => void
        onColumnDrop: (event: React.DragEvent, targetColumnIndex: number) => void
        onColumnDragLeave: (event: React.DragEvent) => void
    }
>

export function BaseOverviewColumn<
    EntityT extends EntityDto,
    FilterT extends BaseOverviewFilterType,
    SortingT extends BaseOverviewSortingType<any>,
    HeaderT extends BaseOverviewCount = BaseOverviewCount,
>(props: BaseOverviewColumnProps<EntityT, FilterT, SortingT, HeaderT>) {
    const styles = useOverviewStyles()

    if (props.viewType === ViewType.KanbanView) {
        return (
            <Card
                className={mergeClasses(styles.flexGrow, styles.flexColumn, props.isDragOver && styles.columnDragOver)}
                onDragOver={props.dragActive ? event => props.onColumnDragOver(event, props.columnIndex) : undefined}
                onDrop={props.dragActive ? event => props.onColumnDrop(event, props.columnIndex) : undefined}
                onDragLeave={props.dragActive ? props.onColumnDragLeave : undefined}
            >
                {props.children}
            </Card>
        )
    }

    return props.children
}
